import { Link, useLocation } from 'react-router-dom';
import styles from './AuthSwitchLink.module.css';

const AuthSwitchLink = () => {
  const location = useLocation();
  const isLoginFlow = location.pathname.startsWith('/login');

  return (
    <div className={styles.wrapper}>
      {isLoginFlow ? (
        <p>
          Don’t have an account?{' '}
          <Link to="/signup/select-role" className={styles.link}>
            Sign Up
          </Link>
        </p>
      ) : (
        <p>
          Already have an account?{' '}
          <Link to="/login/enter-credentials" className={styles.link}>
            Sign In
          </Link>
        </p>
      )}
    </div>
  );
};

export default AuthSwitchLink;